import { useEffect, useState, useCallback } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { PageHeader } from "@/pages/Portal";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const roleColor = { admin: "bg-primary/10 text-primary", client: "bg-blue-100 text-blue-700", technician: "bg-amber-100 text-amber-700" };

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const load = useCallback(() => { api.get("/users").then((r) => setUsers(r.data)); }, []);
  useEffect(() => { load(); }, [load]);

  const del = async (id) => { await api.delete(`/users/${id}`); toast.success("User removed"); load(); };

  return (
    <div className="p-8">
      <PageHeader title="Users" subtitle="Management" />
      <div className="bg-card border border-border rounded-sm overflow-hidden">
        <Table className="min-w-[600px]">
          <TableHeader><TableRow className="bg-muted/50">
            <TableHead>Name</TableHead><TableHead>Email</TableHead><TableHead>Company</TableHead><TableHead>Role</TableHead><TableHead className="text-right">Action</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {users.map((u) => (
              <TableRow key={u.id} data-testid={`user-row-${u.id}`}>
                <TableCell className="font-medium">{u.name}</TableCell>
                <TableCell>{u.email}</TableCell>
                <TableCell>{u.company || "—"}</TableCell>
                <TableCell><Badge className={`rounded-sm capitalize ${roleColor[u.role]}`}>{u.role}</Badge></TableCell>
                <TableCell className="text-right">
                  {u.role !== "admin" && <Button size="icon" variant="ghost" onClick={() => del(u.id)} className="text-primary" data-testid={`delete-user-${u.id}`}><Trash2 size={15} /></Button>}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
